// extracted by mini-css-extract-plugin
module.exports = {"searchLandingRoot":"ZDsXEB4l","content":"mPoCaQzQ"};